 (function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'CruiseSheetPrepareManualPricing',
	};

	$(document).ready(function documentReady()
	{
		var pages = [
			'CruiseSheets/prepareManualPricing',
		];

		Adzuki.onload(pages, function onload() {
			Adzuki.Form.registerForm(form);
		}, false);

	});

	form.load = function load()
	{

		// user toggles a classification (Inside, Ocean view, Balcony, Suite, Unclassified) of ship categories
		$('#cruise-sheet-category-filter select').on('changed.bs.select', function click(e, clickedIndex, isSelected)
		{
			var checked_val = this.options[clickedIndex].value,
			    $rows       = $('#ship-categories-table').find('.' + checked_val);

			$rows.each(function iti( key, value ) {
				var $element = $(this);

				if (isSelected) {
					// on
					$element.removeClass('hidden');
				} else {
					// off
					$element.addClass('hidden');

					// since row will be hidden, remove any currently checked ship_categories
					$element.find('.ship-category-check').prop('checked', false);

					// since ship_category is unchecked, remove any values in row's price fields
					Adzuki.CruiseSheets.clearPricingFields($element);
				}
			});

			categoriesVisible();
		});

		// any changes to form, we want to disable the send button until they successfully save the cruise sheet
		$("#cruise-sheet-form").on("change", function formChange() {
			$('#send-cruise-sheet').prop('disabled', true);
		});


		/**
		 * Are any ship categories visible based on the category filter?  If not, hide the whole "table"
		 */
		function categoriesVisible()
		{
			var $rows   = $('#ship-categories-table').find('.table-row'),
			    visible = false;

			$rows.each(function iti( key, value ) {
				var $element = $(this);

				if (!$element.hasClass('hidden')) {
					visible = true;
					return false;
				}
			});

			if (visible) {
				$('#ship-categories-table').removeClass('hidden');
			} else {
				$('#ship-categories-table').addClass('hidden');
			}
		}
	};

	// form.success = function success(response)
	// {
	// 	var url,
	// 	    link;

	// 	// this is unique to the live pricing option to redirect the form to start the cruise sheet
	// 	if (response.status === 'live_pricing') {
	// 		window.location.href = response.data;

	// 		return false;
	// 	}

	// 	if (!Adzuki.Form.hasError(response)) {
	// 		// in here, so successful form submission
	// 		$('#cruisesheetprepare-id').val(response.data['cruise_sheet_id']);

	// 		$('#cruise-sheets-preview').addClass('hidden');

	// 		$('.cruise-sheets-preview-text').addClass('hidden');
	// 		$('.cruise-sheets-preview-loader').removeClass('hidden');

	// 		// reload iFrame with cruise sheet in it
	// 		url = response.data['cruise_sheet_url'];

	// 		$('#cruise-sheets-preview').attr("src", url);

	// 		$('#cruise-sheet-url-div').removeClass('hidden');

	// 		link = '<a target="_blank" href="' + url + '">' + url + '<a>';
	// 		$('#cruise-sheet-url').html(link);
	// 	}
	// 	return false;
	// };

}(jQuery, window.Adzuki || {}));
